module.exports = __webpack_public_path__ + "static/media/phone-alt-solid.92e4245a.svg";